enum SubscriptionPrivilege {
  Monitoring = "Monitoring",
  MessageCenter = "MessageCenter",
  PerformanceTest = "PerformanceTest",
  Alerts = "Alerts",
}

export default SubscriptionPrivilege
